import BaseService from './base.service';

class ReportService extends BaseService {
  async getCaseReport(reportId, isRecorder = false) {
    return this.get(`/reports/${reportId}?isRecorder=${isRecorder}`);
  }

  async createCaseReport(content, caseId) {
    return this.post(`/reports/${caseId}`, { content, title: '', transcription: '' });
  }

  async voiceTranscription(audioFile) {
    const formData = new FormData();
    formData.append('audioFile', audioFile, 'recording.webm');

    return this.sendFormData('POST', `/reports/voice-transcription`, formData);
  }

  async updateCaseReport(caseReport, content, isRecorder = false) {
    return this.put(`/reports/${caseReport.id}`, { ...caseReport, content, isRecorder, templateId: null, title: '', transcription: null });
  }

  async deleteCaseReport(reportId) {
    return this.delete(`/reports/${reportId}`);
  }
}

export default ReportService;
